import { render, staticRenderFns } from "./bodyprint-declined-view.vue?vue&type=template&id=6949aa1e"
import script from "./bodyprint-declined-view.vue?vue&type=script&lang=js"
export * from "./bodyprint-declined-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports